//! @ngInject
export function approveVisitInstanceRemoveModalCtrl(
    $rootScope,
    $scope,
    $uibModal,
    DatabaseApi,
    $uibModalInstance,
    toaster,
    wildcard,
    noteConsts,
    entityNoteService,
    VisitInstanceModalService,
) {
    $scope.visitInstanceIds = $scope.$resolve.visitInstanceIds;
    $scope.approvalNote = {};
    $scope.manualRemoveNote = {};
    $scope.isManualRemoveVisitNoteRequired = true;
    $scope.isRN = $scope.$resolve.isRN;
    $scope.patientId = $scope.$resolve.patientId;
    // FOR THE APPROVAL NOTE, WE HAVE requestNoteText, indicates 'billing/paid/payroll draft';

    function openRebroadcastTaskModal() {
        const rebroadcastModal = $uibModal.open({
            templateUrl: "admin/views/rebroadcast-task-modal.html",
            size: "md",
            controller: "rebroadcastTaskModalCtrl",
            resolve: {
                visitInstanceId: () => $scope.visitInstanceIds[0],
                patientId: () => $scope.patientId
            }
        });

        return rebroadcastModal.result.then(function(rebroadcastRes) {
            if (rebroadcastRes.success && rebroadcastRes.didBroadcast) {
                toaster.pop('success', "Success", 'Task has been rebroadcasted');
                return true;
            }

            return false;
        });
    }

    function removeVisitInstancesAPI(url, body, noteType, isRemoveNoteAnswer) {
        DatabaseApi.post(url, body).then(function (res) {
            const result = {
                success: res.data.deletedVisitInstanceIds && res.data.deletedVisitInstanceIds.length > 0
            };
            if (body.ids.length === 1 && res.data.deletedVisitInstanceIds.length === 1 && body.manualRemoveNote) {
                const noteSettings = entityNoteService.getAgencyEntityNoteSettingByType(noteType);

                const answer = noteSettings.predefinedAnswers.find(a => a.id === body.manualRemoveNote.notePredefinedAnswerId);
                result.manualRemovedVisitNote = body.manualRemoveNote;
                result.manualRemovedVisitNote.predefinedAnswerText = answer.text;
                result.isRemoveNoteAnswer = isRemoveNoteAnswer;
            }
            if (res.data.skippedVisitsAndMissingPermissions) {
                VisitInstanceModalService.showSkippedVisitsErrorModal({
                    skippedVisitsAndMissingPermissions: res.data.skippedVisitsAndMissingPermissions,
                    updatedVisitsAmount: res.data.deletedVisitInstanceIds.length,
                    action: "delete"
                });
            } else {
                toaster.pop('success', "Success", 'Visit instances removed successfully');
            }

            $uibModalInstance.close(result);
        }, function (err) {
            toaster.pop('error', 'Something went wrong', "Couldn't delete visit instance");
        });
    }

    $scope.approveForm = () => {
        const isRemoveNoteAnswer = entityNoteService.getAgencyEntityNoteSettingByType(noteConsts.NoteTypes.VISIT_MANUAL_REMOVE).predefinedAnswers.find(a => a.id === $scope.manualRemoveNote.notePredefinedAnswerId) !== undefined;
        const noteType = $scope.isRN ? noteConsts.NoteTypes.AGENCY_MEMBER_REMOVE_TASK_VISIT : isRemoveNoteAnswer ? noteConsts.NoteTypes.VISIT_MANUAL_REMOVE : noteConsts.NoteTypes.MISSED_VISIT_INSTANCE;

        const { isNoteValid, isPredefinedValid, isMessageValid } = entityNoteService.validateEntityNote(
            $scope.manualRemoveNote,
            noteType
        );
        if (!isNoteValid) {
            $scope.removedVisitNoteValidations = { isPredefinedValid, isMessageValid };
            return;
        }

        if ($scope.$resolve.requestNoteText) {
            const { isNoteValid, isPredefinedValid, isMessageValid } = entityNoteService.validateEntityNote(
                $scope.approvalNote, 
                noteConsts.NoteTypes.ADJUSTMENT_APPROVAL
            );
            if (!isNoteValid) {
                $scope.approvalNoteValidations = { isPredefinedValid, isMessageValid };
                return;
            }
        }

        const url = wildcard(
            "agencies/:agencyId/agency_members/:agencyMemberId/remove_visit_instances",
            $rootScope.agencyId,
            $rootScope.agencyMemberId
        );
        const body = {
            ids: $scope.visitInstanceIds,
        };


        body.manualRemoveNote = entityNoteService.buildEntityNoteRequest(
            $scope.manualRemoveNote,
            noteType,
        );

        if ($scope.$resolve.requestNoteText) {
            body.approvalNote = entityNoteService.buildEntityNoteRequest(
                $scope.approvalNote,
                noteConsts.NoteTypes.ADJUSTMENT_APPROVAL,
            );
        }

        if ($scope.isRN) {
            openRebroadcastTaskModal().then(result => {
                body.broadcastTask = result;
                removeVisitInstancesAPI(url, body, noteType, isRemoveNoteAnswer);
            });
        } else {
            removeVisitInstancesAPI(url, body, noteType, isRemoveNoteAnswer);
        }

    }

    $scope.handleNoteChanges = (noteModel, updatedNote) => {
        $scope[noteModel] = updatedNote;
    };

    $scope.closeModal = function (data) {
        $uibModalInstance.close(data);
    };

    $scope.getNoteTypes = () => {
        return $scope.isRN ? ['removed_task'] : ['visit_manual_remove','missed_visit_instance'];
    };
};